<template>
  <v-list dense>
    <v-list-item key="signout" @click="signOut()">
      <v-list-item-icon>
        <v-icon>mdi-power</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Sign Out</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-dialog
      v-model="showDeletionWarning"
      width="50%"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-list-item key="delete" v-bind="attrs"
        v-on="on">
          <v-list-item-icon>
            <v-icon>mdi-account-remove-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Delete Account</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-card>
        <v-card-title class="headline red lighten-2">
          You will lose all data
        </v-card-title>

        <v-card-text>
          To delete your account SEND A MAIL TO init.giorgio@gmail.com from the mail address that you used to sign up here with a short notice.
          We will then delete your name and mail from our servers and you cannot access your saved persons anymore!This is irreversible.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-progress-circular
            indeterminate
            color="blue"
            v-if="showLoadingDeletion"
          ></v-progress-circular>
          <!--<v-btn
            color="primary"
            text
            @click="showDeletionWarning = false"
            v-if="!showLoadingDeletion"
          >
            CANCEL
          </v-btn>-->
          <v-btn
            color="primary"
            text
            @click="showDeletionWarning = false"
            v-if="!showLoadingDeletion"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-subheader>LEGAL INFO</v-subheader>
    <v-list-item key="dataprivacy" to="/privacy">
      <v-list-item-content>
        <v-list-item-title>Data privacy</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item key="legalnotice" to="/legal">
      <v-list-item-content>
        <v-list-item-title>Legal notice</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

  </v-list>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
var firebase = require('firebase');

export default {
  name: 'Account',
  components: {
  },
  data() {
    return {
      auth: this.$root.$data.auth,
      showDeletionWarning: false,
      showLoadingDeletion: false,
    }
  },
  methods: {
    signOut() {
      this.auth.signOut();
    },
    async deleteAccount() {
      // This is not working properly! Error: Invalid email link!
      let credential = firebase.auth.EmailAuthProvider.credentialWithLink(this.auth.currentUser.email, window.location.href);
      try {
        await this.auth.currentUser.reauthenticateWithCredential(credential);
      } catch (error) {
        console.log(`Error requthenticating: ${error}`);
        this.showDeletionWarning = false;
        return;
      }
      this.showLoadingDeletion = true;

      try {
        await this.auth.currentUser.delete();
      } catch (error) {
        console.log(`Error deleting your account: ${error}`);
        this.showDeletionWarning = false;
        this.showLoadingDeletion = false;
        return;
      }

      this.auth.signOut();
    }
  }
}
</script>
